import { render, staticRenderFns } from "./TestReport.vue?vue&type=template&id=ab70fc48&"
import script from "./TestReport.vue?vue&type=script&lang=js&"
export * from "./TestReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports